import React from "react";
import PaymentSuccessContainer from "../containers/PaymentSuccess";
import MainLayout from "../layouts/MainLayout";

const PaymentSuccess = () => {
  return (
    <MainLayout>
      <PaymentSuccessContainer />
    </MainLayout>
  );
};

export default PaymentSuccess;
